<!--
 * @Description: Description
 * @Author: zhaoqianqian
 * @Date: 2022-06-30 18:04:56
 * @LastEditors: liutq
 * @LastEditTime: 2025-04-03 11:09:14
-->
<template>
    <!-- 头部信息 -->
    <div class="header-info">
        <div :class="['nickname',$i18n.locale]">
            <div class="nick-name">
                <!-- 昵称 -->
                <span style="padding-top:19px">{{ memberInfo.name || fomatterIphone(memberInfo.mobile) || email }}</span>
                <img v-if="memberInfo.sex === 1" src="@/assets/images/report/nan.png" alt="">
                <img v-else-if="memberInfo.sex === 2" src="@/assets/images/report/nv.png" alt="">
            </div>
            <div :class="['info',$i18n.locale]">
                <div class="span">
                    <!-- 身高 -->
                    <span>{{ infoText('userInfo.height') }}</span>
                    <span class="age height">{{ height }}</span>
                </div>

                <div class="span">
                    <!-- 年龄 -->
                    <span>{{ infoText('userInfo.age') }}</span>
                    <span class="age">{{ memberInfo.age }} {{ infoText('userInfo.unit') }}</span>
                </div>

                <div class="span">
                    <!-- 体重 -->
                    <span v-if="deviceType === 3">{{ $t('userInfo.weight') }}：</span>
                    <span v-if="deviceType === 3" class="weight">{{ weight }} </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getMemberInfo, findBmMassQuotaInfos } from '@/assets/js/apolloGql.js'
import { _toDecimal,_unitTranslation } from '@/assets/js/util.js'

const M60S_INFO_LABELS = {
    'bg-BG': { 'userInfo.height': 'Ръст:', 'userInfo.age': 'Възраст:', 'userInfo.unit': 'г.' },
    'hr-HR': { 'userInfo.height': 'Visina:', 'userInfo.age': 'Dob:', 'userInfo.unit': 'god.' },
    'ko-KR': { 'userInfo.height': '키:', 'userInfo.age': '나이:', 'userInfo.unit': '세' },
    'lt-LT': { 'userInfo.height': 'Ūgis:', 'userInfo.age': 'Amžius:', 'userInfo.unit': 'm.' },
    'nl-NL': { 'userInfo.height': 'Lengte:', 'userInfo.age': 'Leeftijd:', 'userInfo.unit': 'jaar' },
    'sk-SK': { 'userInfo.height': 'Výška:', 'userInfo.age': 'Vek:', 'userInfo.unit': 'r.' },
    'sr-RS': { 'userInfo.height': 'Visina:', 'userInfo.age': 'Starost:', 'userInfo.unit': 'god.' },
    'uk-UA': { 'userInfo.height': 'Зріст:', 'userInfo.age': 'Вік:', 'userInfo.unit': 'р.' },
}

export default {
    props: {
        massInfo: Object,
        m60S: { type: Boolean, default: false },
    },
    data() {
        return {
            modelInfo: JSON.parse(window.localStorage.getItem('modelInfo')),
            deviceType: JSON.parse(window.localStorage.getItem('deviceType')),
            unit: window.localStorage.getItem('unit'),
            memberInfo: {
                name: '',
                height: '',
                age: '',
                sex: null,
                mobile: ''
            },
            weight: '- -',
            email: window.localStorage.getItem('email'),
        }
    },
    computed: { 
        height() {
            const height = this.memberInfo.height
            // 如果没有身高数据
            if (!height) return ''
            const local = this.$i18n.locale
             // 支持英制单位的完整语言列表
            const normalList = [
                'en-US', 'ja-JP', 'zh-CN', 'tr-TR', 'de-DE', 'id-ID', 'pt-PTO',
                'th-TH', 'ar-AR', 'el-GR', 'it-IT', 'es-ES', 'fr-FR', 'ru-RU',
                'de-DE', 'zh-TW', 'zh-HK', 'pt-PT', 'cs-CZ', 'hu-HU', 'sv-SE',
                'fi-FI'
            ]
            // 只显示
            if (!normalList.includes(local)) return `${Math.round(height * 2.54)} cm`

            // 如果单位是英制，则显示英尺和英寸格式
            if (this.unit === 'imperial') {
                const heightFt = Math.floor(Math.round(height) / 12)
                const heightIn = Math.floor(Math.round(height) % 12)
                
                // 根据不同语言显示不同的单位标签
                if (local === 'ar-AR') return `${heightFt} قدم. ${heightIn} بوصة.`
                if (local === 'es-ES') return `${heightFt} pies. ${heightIn} pulg.`
                if (local === 'fr-FR') return `${heightFt} pi. ${heightIn} po.`
                if (local === 'th-TH') return `${heightFt} ฟุต ${heightIn} นิ้ว`
                return `${heightFt} ft. ${heightIn} in.`
            } else {
                // 如果单位是公制，则显示厘米
                if (local === 'ar-AR') return `${Math.round(height * 2.54)} سم`
                return `${Math.round(height * 2.54)} cm`
            }
        }
    },
    created() {
        // 获取用户信息
        this.getMemberInfo()
        if(this.massInfo && this.massInfo.scanId && this.deviceType === 3) {
            this.bmMassContrasInfo()
        }
    },
    methods: {
        infoText(key) {
            const locale = this.$i18n.locale === 'sr-CS' ? 'sr-RS' : this.$i18n.locale
            const isolated = this.m60S ? M60S_INFO_LABELS[locale] : null
            return (isolated && isolated[key]) || this.$t(key)
        },
        // 格式化手机号显示
        fomatterIphone(str) {
            let result = str || ''
            const phoneLen = result.length
            if (phoneLen > 14) {
                result = result.substr(0, 7) + '****' + result.substr(phoneLen - 4)
            } else if (phoneLen === 14) {
                result = result.substr(0, 6) + '****' + result.substr(phoneLen - 4)
            } else if (phoneLen > 7) {
                result = result.substr(0, 5) + '*'.repeat(phoneLen - 7) + result.substr(phoneLen - 2)
            }
            return result
        },
        // 侧边栏 获取用户信息
        getMemberInfo() {
            this.$apollo
                .query({
                    query: getMemberInfo
                })
                .then(res => {
                    const data = res.data.getMemberInfo
                    if (data && data.code === 200) {
                        this.memberInfo = data.data
                        window.localStorage.setItem('memberInfo', JSON.stringify(data.data))
                    }
                })
        },
        bmMassContrasInfo() {
            this.$apollo
                .query({
                    query: findBmMassQuotaInfos,
                    variables: {
                        memberId: this.modelInfo.memberId,
                        scanId: this.massInfo.scanId,
                        tcScanId: '',
                        deviceType: this.deviceType
                    },
                    fetchPolicy: 'network-only'
                })
                .then(res => {
                    const data = res.data.findBmMassQuotaInfos
                    if (data.code === 200) {
                      data.data.forEach((value) => {
                        if(value.order === -1){
                            return
                        }
                        if (value.dataColumn === 'WT') {
                            if (this.unit === 'metric' && value.unit === 'kg') {
                                if (value.latestData) { 
                                    this.weight = `${this.toDecimal(value.latestData.v, 1)} ${this.unitTranslation('kg')}`
                                    console.log(this.weight,'tizhong')
                                }
                            } 
                            if (this.unit === 'imperial' && value.unit === 'kg') {
                                // value.unit = 'lbs'
                                if(this.$i18n.locale==='ar-AR'){
                                    this.weight = `${ this.toDecimal2(value.latestData.v)} رطل`
                                }else{
                                    this.weight = `${ this.toDecimal2(value.latestData.v)} lbs`
                                }
                                
                            }
                        }
                      });
                        
                    }
                })
        },
        unitTranslation(unit){ 
            return _unitTranslation(unit, this.$i18n.locale) 
        },
        toDecimal(num, digit) {
            return _toDecimal(num * 0.45359237, digit)
        },
        toDecimal2(x, y) {
            let f = Math.round(x * 100) / 100
            let s = f.toString()
            let rs = s.indexOf('.')
            if (rs < 0) {
                rs = s.length
                s += '.'
            }
            while (s.length <= rs + y) {
                s += '0'
            }
            return s
        },
    }

}
</script>

<style lang="less" scoped>
.header-info {
    display: flex;
    align-items: center;
    width: 353px;
    // background-color: #303358;
    background: url(../../assets/images/report/bj.png) center no-repeat;
    background-size: 100% 100%;
    margin: 0px 15px 0 11px;
    padding-bottom: 15px;
    font-size: 12px;
    color: #fff;

    .nickname {
        width: 353px;
        height: 78px;
        text-align: left;
        .nick-name {
            margin: 0px 16px 12px 16px;
            font-size: 14px;
            font-weight: bold;
            white-space: nowrap;
            margin-top: 3px;

            img {
                margin-left: 5px;
                width: 14px;
                height: 14px;
            }

            span {
                display: inline-block;
                font-size: 14px;
                font-weight: 400;
                max-width: 308px;
                height: auto;
                word-wrap: break-word;
                /*强制换行*/
                overflow: hidden;
                /*超出隐藏*/
                text-overflow: ellipsis;
                /*隐藏后添加省略号*/
                line-height: 16px;
            }
        }
        .info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-left: 15px;
            padding-right: 15px;

            .span {
                display: inline-block;
                font-size: 14px;
                font-weight: 400;
                max-width: 308px;
                height: auto;
                word-wrap: break-word;
                /*强制换行*/
                // overflow: hidden;
                /*超出隐藏*/
                text-overflow: ellipsis;
                /*隐藏后添加省略号*/
                line-height: 16px;
                color: #8AA3BE;
            }
        }
    }

   

    .nickname>span {
        margin-left: 16px;
        display: initial;
        text-align: left;
        font-size: 14px;
        color: #8AA3BE;
    }
    .age {
        margin-left: 5px !important;
       // width: 110px !important;
        margin-right: 20px !important;
    }
   
    .height {
        margin-right: 25px !important;
    }

    .weight {

    }

}
/* pl-PL: 用户信息三列固定单行，避免单位换行 */
.header-info {
    .nickname.pl-PL {
        .info {
            gap: 8px;
            flex-wrap: nowrap;
            justify-content: space-between;
            .span {
                display: flex;
                align-items: center;
                flex-wrap: nowrap;
                min-width: 0;
                max-width: none;
                white-space: nowrap;
                word-wrap: normal;
                word-break: keep-all;
            }
            .span > span {
                white-space: nowrap !important;
            }
            /* 仅锁定数值+单位不换行（如 174 cm / 25 lat(a) / 70.4 kg） */
            .age,
            .weight {
                display: inline-flex;
                align-items: center;
                white-space: nowrap !important;
                word-break: keep-all;
            }
            .age {
                margin-right: 8px !important;
            }
            .height {
                margin-right: 8px !important;
            }
        }
    }
}
&.tr-TR,
&.de-DE,
&.cs-CZ,
&.el-GR{
    .age {
        margin-left: 5px !important;
       // width: 110px !important;
        margin-right: 0px !important;
    }
   
    .height {
        margin-right: 0px !important;
    }
}
&.es-ES{
    .height {
        margin-right: 5px !important;
    }
}
&.ar-AR{
    .nick-name{
        text-align: right;
        img{
            margin-right: 4px;
        }
    }
    .header-info{
           margin: 0px 11px 0 11px;
    }
    .info{
       .span .age{
        margin: 0 10px !important;
       }
    }

}
</style>

